<div class="multi-location-editor">
  <!-- Global Default Section -->
  <div class="global-section">
    <div class="section-header">
      <h4>{{ 'WORK_SCHEDULE.Default_Schedule' | translate }}</h4>
      <p class="hint-text">{{ 'WORK_SCHEDULE.Default_Schedule_Hint' | translate }}</p>
    </div>

    <div class="schedule-row">
      <div class="schedule-field">
        <label>{{ 'WORK_SCHEDULE.Work_Days' | translate }}</label>
        <ion-select
          [(ngModel)]="globalWorkDaysID"
          (ionChange)="onGlobalWorkDaysChange()"
          interface="popover"
          class="schedule-select">
          <ion-select-option
            *ngFor="let opt of workDaysScheduleOptions"
            [value]="opt.scheduleID">
            {{ opt.name }}
          </ion-select-option>
        </ion-select>
      </div>

      <div class="schedule-field">
        <label>{{ 'WORK_SCHEDULE.Days_Off' | translate }}</label>
        <ion-select
          [(ngModel)]="globalDaysOffID"
          (ionChange)="onGlobalDaysOffChange()"
          interface="popover"
          class="schedule-select">
          <ion-select-option
            *ngFor="let opt of daysOffScheduleOptions"
            [value]="opt.scheduleID">
            {{ opt.name }}
          </ion-select-option>
        </ion-select>
      </div>
    </div>
  </div>

  <!-- Location Overrides Section -->
  <div class="locations-section" *ngIf="sortedLocations.length > 0">
    <div class="section-header">
      <h4>{{ 'WORK_SCHEDULE.Location_Overrides' | translate }}</h4>
      <p class="hint-text">{{ 'WORK_SCHEDULE.Location_Overrides_Hint' | translate }}</p>
    </div>

    <div class="location-cards">
      <div class="location-card" *ngFor="let location of sortedLocations">
        <div class="location-header">
          <div class="location-info">
            <span class="location-name">{{ location.locationName }}</span>
            <span class="asset-count">
              {{ 'WORK_SCHEDULE.Assets_Count' | translate:{ count: location.assetCount } }}
            </span>
          </div>
          <ion-button
            *ngIf="hasLocationOverride(location.locationID)"
            fill="clear"
            size="small"
            color="medium"
            (click)="resetLocationToDefaults(location.locationID)">
            <ion-icon name="refresh-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>

        <div class="schedule-row">
          <div class="schedule-field">
            <label>{{ 'WORK_SCHEDULE.Work_Days' | translate }}</label>
            <ion-select
              [ngModel]="getLocationSchedule(location.locationID).workDaysScheduleID"
              (ionChange)="setLocationWorkDays(location.locationID, $event.detail.value)"
              interface="popover"
              class="schedule-select">
              <ion-select-option
                *ngFor="let opt of workDaysScheduleOptions"
                [value]="opt.scheduleID">
                {{ opt.name }}
              </ion-select-option>
            </ion-select>
          </div>

          <div class="schedule-field">
            <label>{{ 'WORK_SCHEDULE.Days_Off' | translate }}</label>
            <ion-select
              [ngModel]="getLocationSchedule(location.locationID).daysOffScheduleID"
              (ionChange)="setLocationDaysOff(location.locationID, $event.detail.value)"
              interface="popover"
              class="schedule-select">
              <ion-select-option
                *ngFor="let opt of daysOffScheduleOptions"
                [value]="opt.scheduleID">
                {{ opt.name }}
              </ion-select-option>
            </ion-select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Calendar Preview Section -->
  <div class="preview-section">
    <div class="section-header">
      <h4>{{ 'WORK_SCHEDULE.Calendar_Preview' | translate }}</h4>
      <div class="preview-location-select" *ngIf="sortedLocations.length > 1">
        <label>{{ 'WORK_SCHEDULE.Preview_For' | translate }}</label>
        <ion-select
          [(ngModel)]="selectedPreviewLocationID"
          (ionChange)="onPreviewLocationChange()"
          interface="popover"
          class="location-select">
          <ion-select-option [value]="0">
            {{ 'WORK_SCHEDULE.All_Locations' | translate }}
          </ion-select-option>
          <ion-select-option
            *ngFor="let location of sortedLocations"
            [value]="location.locationID">
            {{ location.locationName }}
          </ion-select-option>
        </ion-select>
      </div>
    </div>

    <div class="calendar-container">
      <app-schedule-calendar
        [workDaysScheduleID]="cachedPreviewWorkDaysID"
        [daysOffScheduleID]="cachedPreviewDaysOffID"
        [locationID]="selectedPreviewLocationID"
        [subjectType]="subjectType"
        [subjectID]="subjectID"
        [showLegend]="true"
        [readonly]="true">
      </app-schedule-calendar>
    </div>
  </div>
</div>
